export const FormInfo = {
  AQ10:
    {name:'AQ-10',
    maxColumn:4,
    numRows:10},

  AQ50:
    {name:'AQ-50',
    maxColumn:4,
    numRows:50},

  Development:
    {name:'Development',
    maxColumn:4,
    numRows:5},

  Environmental: 
    {name:'Environmental',
    maxColumn:4,
    numRows:4},

  Wellness:
    {name:'Wellness',
    maxColumn:4,
    numRows:11},

  WHO5:
    {name:'WHO-5',
    maxColumn:6,
    numRows:5},

  Trauma:
    {name:'Trauma',
    maxColumn:2,
    numRows:6},

  PTSD:
    {name:'PCL-C',
    maxColumn:5,
    numRows:17},

  BPD:
    {name:'MSI-BPD',
    maxColumn:2,
    numRows:10},

  ASRS5:
    {name:'ASRS-5',
    maxColumn:5,
    numRows:6},

  DAST:
    {name:'DAST-10',
    maxColumn:2,
    numRows:10},

  Family:
    {name:'Family',
    maxColumn:9,
    numRows:13},

  MDQ:
    {name:'MDQ',
    maxColumn:4,
    numRows:15},

  GAD:
    {name:'GAD-7',
    maxColumn:4,
    numRows:8},

  PHQ9:
    {name:'PHQ-9',
    maxColumn:4,
    numRows:10},

  AUDIT:
    {name:'AUDIT',
    maxColumn:5,
    numRows:10},

  Medication:
    {name:'Medication',
    maxColumn:5,
    numRows:87},

  Prime:
    {name:'PRIME',
    maxColumn:7,
    numRows:12},

  ASRS1: 
    {name:'ASRS v1.1',
    maxColumn:5,
    numRows:18},

  ASRS: 
    {name:'ASRS',
    maxColumn:5,
    numRows:18},

  ASRM:
    {name:'ASRM',
    maxColumn:1,
    numRows:5},

  TAS20:
  {name:'TAS-20',
    maxColumn:5,
    numRows:20},
  PTQ:
    {name:'PTQ',
      maxColumn:5,
      numRows:15},
  CATQ:
    {name:'CAT-Q',
      maxColumn:7,
      numRows:25},
  PMDD:
    {name:'PMDD',
    maxColumn:2,
    numRows:15},

  Introduction:
    {name:'Introduction'},

  FinalPage:
    {name:'FinalPage'}
}

export const TriageForms = [FormInfo.AQ10.name,FormInfo.PHQ9.name,FormInfo.WHO5.name,FormInfo.MDQ.name,FormInfo.GAD.name,
  FormInfo.DAST.name,FormInfo.BPD.name,FormInfo.ASRS5.name,FormInfo.AUDIT.name];

export const ScoredForms = [FormInfo.AQ10.name,FormInfo.PHQ9.name,FormInfo.WHO5.name,FormInfo.MDQ.name,FormInfo.GAD.name,FormInfo.PTSD.name,
  FormInfo.DAST.name,FormInfo.BPD.name,FormInfo.ASRS5.name,FormInfo.AUDIT.name,FormInfo.AQ50.name,FormInfo.ASRS1.name,FormInfo.ASRM.name, FormInfo.Prime.name,
  FormInfo.ASRS.name,FormInfo.TAS20.name,FormInfo.PTQ.name,FormInfo.CATQ.name,FormInfo.PMDD.name];
  
export const TriageScore = {
  PHQ9:
    {high:15,
    medium:10,
    low:5},

  GAD:
    {high:15,
    medium:10,
    low:5},
  
  MDQ:
    {high:7,
    medium:5,
    low:3},
  
  BPD:
    {high:7,
    medium:5,
    low:3},

  AQ10:
    {high:9,
    medium:8,
    low:6},

  ASRS5:
    {high:21,
    medium:17,
    low:10},
  
  AUDIT:
    {high:15,
    medium:8,
    low:3},

  DAST:
    {high:7,
    medium:5,
    low:3},

  WHO5:
    {high:10,
    medium:15,
    low:20},

  Total:
    {high:3,
    medium:2,
    low:1}
}